import { useState } from 'react'

import CheckIcon from '@/assets/icons/icon-check.svg'
import { Button } from '@/components/ui/button.tsx'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover.tsx'
import { classNames } from '@/utils/helpers.ts'

import CloseIcon from '../../../assets/icons/icon-close.svg'
import type { BillingPlan } from '../types'

interface Props {
  license: BillingPlan
  className?: string
}

export const LicenseBenefitsPopover = ({ license, className }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleClose = () => setIsOpen(false)

  return (
    <Popover
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          className={classNames('absolute', className)}
        >
          See Features
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className="z-100 w-[30rem] rounded-xl p-6"
        align="start"
        alignOffset={-173}
        side="right"
        sideOffset={75}
      >
        <div className="grid gap-4">
          <div className="flex items-center justify-between">
            <h5 className="font-medium text-title">
              {license.displayName} License Features
            </h5>
            <CloseIcon
              className="cursor-pointer text-secondary-200"
              onClick={handleClose}
            />
          </div>
          {license.displayBenefits.map((benefit, i) => (
            <div
              key={benefit.substring(0, 5) + i}
              className="grid grid-flow-col items-center justify-start gap-2"
            >
              <CheckIcon className="text-success-default" />
              <p className="text-title">{benefit}</p>
            </div>
          ))}
          {license.displayNonBenefits.map((benefit, i) => (
            <div
              key={benefit.substring(0, 5) + i}
              className="grid grid-flow-col items-center justify-start gap-2"
            >
              <CloseIcon className="text-danger-default" />
              <p className="text-title">{benefit}</p>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  )
}
